import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutIronPeakMensHealth from "./sections/AboutIronPeakMensHealth";
import TestosteroneReplacementTherapyTRT from "./sections/TestosteroneReplacementTherapyTRT";
import LongevitySolutions from "./sections/LongevitySolutions";
import ComprehensiveAssessments from "./sections/ComprehensiveAssessments";
import ClientTestimonials from "./sections/ClientTestimonials";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
import CallToAction from "./sections/CallToAction";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <LongevitySolutions />
      <AboutIronPeakMensHealth />
      <ComprehensiveAssessments />
      <CallToAction />
      <TestosteroneReplacementTherapyTRT />
      <ClientTestimonials />
      <ContactUs />
      <Footer />
    </div>;
}